<template>
  <div>
    <el-row :gutter="30">
      <el-col :span="6" class="sidebar">
        <router-link :to="{ name: 'Add CustomForm' }">
          <el-button type="primary" class="fluid"
            >{{ $t('add') }} Formularz <i class="el-icon-plus"></i>
          </el-button>
        </router-link>
        <ListFilterComponent
          @setFilter="setFilter"
          :selectedFilters="filters.selected"
          :listFilters="filters.available"
        >
        </ListFilterComponent>
      </el-col>
      <el-col class="box" :span="18">
        <div class="list__header">
          <p class="list__title">
            {{ getRouteName($route) }}
            <span
              ><br />Usunięcie formularza i edycja są możliwe tylko, jeśli nie
              ma żadnego wypełnionego formularza.</span
            >
          </p>
          <search-list-form
            v-model="filters.selected.search"
            @submit="fetchData"
          />
        </div>
        <preview-dialog
          :bus="bus"
          @nextPreview="nextPreview"
          @previousPreview="previousPreview"
          @cancel="dialogCancelled"
          @submit="dialogSubmitted"
        />
        <el-table
          :data="data"
          highlight-current-row
          v-loading="listLoading"
          class="list__table"
          style="width: 100%;"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <p v-for="(data, i) in props.row.formdata_set" :key="i">
                <span class="formdata-entry">
                  {{ i + 1 }}. {{ data.timestamp }}
                </span>
                <el-button
                  size="mini"
                  @click="openDialog(data, props.row)"
                  title="Podgląd"
                >
                  Podgląd
                </el-button>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="id" width="80"></el-table-column>
          <el-table-column prop="name_pl" label="nazwa (pl)"></el-table-column>
          <el-table-column prop="name_en" label="nazwa (en)"></el-table-column>
          <el-table-column label="liczba zgłoszeń">
            <template slot-scope="scope">
              {{ scope.row.formdata_set.length }}
            </template>
          </el-table-column>
          <el-table-column label="opcje" width="240" class="pull-right">
            <template slot-scope="scope" class="pull-right">
              <el-button
                size="small"
                :loading="exportLoading"
                @click="exportFormDataDialog(scope.row)"
                v-if="hasAnswers(scope.row)"
                title="Eksportuj"
              >
                <i class="el-icon-download"></i>
              </el-button>
              <router-link
                :to="{ name: 'Edit CustomForm', params: { id: scope.row.id } }"
                v-if="!hasAnswers(scope.row)"
              >
                <el-button size="small" :title="$t('edit')">
                  <i class="el-icon-edit"></i>
                </el-button>
              </router-link>
              <el-button
                type="danger"
                size="small"
                :title="$t('delete')"
                @click="handleDelete(scope.$index, scope.row)"
                ><i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { CustomForm } from '@/api/'
import ListFilterComponent from '@/views/CustomForms/components/ListFilterComponent'
import PreviewDialog from '@/views/CustomForms/PreviewDialog'
import Vue from 'vue'

export default {
  data() {
    return {
      filters: {
        available: [],
        selected: {}
      },
      data: [],
      listLoading: false,
      service: CustomForm,
      count: 0,
      page: 1,
      pageSize: 10,
      bus: new Vue(),
      currentPreview: null,
      currentForm: null,
      exportLoading: false
    }
  },
  methods: {
    handlePageChange(val) {
      this.page = val
      this.fetchData()
    },
    hasAnswers(form) {
      return form.formdata_set.length > 0
    },
    setFilter(filter) {
      this.page = 1
      const key = filter.query_param
      const value = filter.value
      this.$set(this.filters.selected, key, value)
      this.fetchData()
    },
    fetchData() {
      let params = {
        page: this.page,
        ...this.filters.selected
      }
      this.listLoading = true
      this.service.fetch({}, { params }).then(response => {
        this.count = response.data.count
        this.pageSize = response.data.page_size
        this.data = response.data.results
        this.listLoading = false
      })
    },
    async handleDelete(index, row) {
      await this.$confirm(
        this.$i18n.t('deleteConfirmation'),
        this.$i18n.t('delete'),
        {
          type: 'warning'
        }
      )

      this.listLoading = true
      await this.service.delete(row.id)

      this.listLoading = false
      this.$message({
        message: 'Element został usunięty',
        type: 'success'
      })

      this.fetchData()
    },
    dialogCancelled() {
      // cancel
    },
    dialogSubmitted() {
      // submit
    },
    openDialog(data, form) {
      this.currentPreview = data
      this.currentForm = form
      this.bus.$emit('openPreviewDialog', data)
    },
    nextPreview() {
      console.log()
      this.changePreview(1)
    },
    previousPreview() {
      this.changePreview(-1)
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\wąęśćżźńłó-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    changePreview(diff) {
      if (this.currentPreview == null || this.currentForm == null) return

      const currentIndex = this.currentForm.formdata_set.indexOf(
        this.currentPreview
      )

      if (
        currentIndex + diff < 0 ||
        currentIndex + diff > this.currentForm.formdata_set.length - 1
      ) {
        return
      }

      const nextPreview = this.currentForm.formdata_set[currentIndex + diff]

      this.openDialog(nextPreview, this.currentForm)
    },
    exportFormDataDialog(form) {
      if (form.formdata_set.length > 1000) {
        this.$prompt(
          'Wprowadź adres e-mail, na który zostanie wysłany wyeksportowany formularz',
          'E-mail',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Niepoprawny adres e-mail'
          }
        )
          .then(({ value }) => {
            this.exportFormData(form, value)
          })
          .catch(() => {})
      } else {
        this.exportFormData(form)
      }
    },
    exportFormData(form, email) {
      this.exportLoading = true
      CustomForm.exportFormData(form.id, email)
        .then(response => {
          const isFile = response.data instanceof Blob
          if (isFile) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${this.slugify(form.name_pl)}.xlsx`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.$message({
              message: 'Plik zostanie wysłany na podany email',
              type: 'success'
            })
          }
        })
        .catch(err => {
          this.$message({
            message: 'Wystąpił bład podczas pobierania danych.',
            type: 'error'
          })
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  },
  mounted() {
    this.fetchData()
  },
  components: {
    ListFilterComponent,
    PreviewDialog
  }
}
</script>
<style lang="scss" scoped>
.formdata-entry {
  margin-right: 20px;
}
</style>
